import { openSnackbar } from '../components/shared/AktivuSnackbar/snackSlice';

/**
 * returns toggle payload
 * @param {boolean} isActive - true / false
 * @returns {object} togglePayload - toggle payload
 */
export const getTogglePayload = isActive => {
  const togglePayload = {
    fields: [
      {
        field: 'is_active',
        value: isActive ? 'false' : 'true',
      },
    ],
  };

  return togglePayload;
};

/**
 * returns delete type
 * @param {object} row - row object
 * @returns {string} delType - deletion type
 */
export const getDelType = row => {
  let delType = 'remove';

  if (!row.is_active) {
    delType = 'restore';
  }

  return delType;
};

/**
 * capitalizes string
 * @param {string} str - string to be capitalized
 * @returns {string} str - capitalized string
 */
export const capitalizeIt = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Delete or Restore functionality on the grids
 * @param {object} func - function to be called for remove / restore
 * @param {boolean} rowActive - true/false
 * @param {integer} id - identifier
 * @param {string} actionType - action type
 * @param {string} moduleName - module name
 * @param {object} dispatch - dispatch function
 */
export const deleteOrRestore = async (
  func,
  rowActive,
  id,
  actionType,
  moduleName,
  dispatch
) => {
  const togglePayload = getTogglePayload(rowActive);

  let snackPayload = {
    moduleName,
    actionType,
  };

  try {
    await func({
      ...togglePayload,
      id: [id],
    }).unwrap();

    dispatch(openSnackbar(snackPayload));
  } catch (err) {
    dispatch(
      openSnackbar({
        ...snackPayload,
        hasError: true,
      })
    );
  }
};

/**
 * returns bucket name based on the upload type
 * @param {*} uploadType
 * @returns
 */
export const getBucketName = uploadType => {
  let bucketName = 'generic.files';
  if (uploadType === 'product-spec') {
    bucketName = 'files.product.specs';
  } else if (uploadType === 'logo') {
    bucketName = 'files.organization.logos';
  } else if (uploadType === 'raw') {
    bucketName = 'raw.organization.files';
  }
  bucketName = `${process.env.NODE_ENV}.${bucketName}`;
  return bucketName;
};

/**
 * check the validity of the token
 * @param {*} token
 * @returns
 */
export const decodeAndCheckToken = token => {
  try {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));

    if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
      return false;
    }
    return true;
  } catch (e) {
    console.error(`Error parsing JWT token ${e}`);
    return false;
  }
};

/**
 * retrieve permissions from the jwt token
 * @param {*} token
 * @returns
 */
export const getPermsFromToken = token => {
  try {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    return decodedToken?.perms || [];
  } catch (e) {
    console.error(`Error parsing JWT token ${e}`);
    return false;
  }
};

/**
 * determine allowed routes based on the role
 * @param {*} perms
 * @param {*} routes
 * @returns
 */
export const getAllowedRoutes = (perms, routes, role) => {
  const allowedRoutes = [];

  // avoid mutation of original Routes collection
  const clonedRoutes = routes.map(i => ({ ...i }));

  for (let i = 0; i < clonedRoutes.length; i++) {
    const route = clonedRoutes[i];
    if (route.type === 'group') {
      const children = route.children;

      if (
        route.name === 'Solution' &&
        role !== 'pycube_admin' &&
        role !== 'csm'
      ) {
        allowedRoutes.push(route);
      } else {
        const allowedChildren = children.filter(
          c => perms.includes(c.path) && c.isActive
        );

        route.children = allowedChildren;
        if (allowedChildren.length > 0) {
          allowedRoutes.push(route);
        }
      }
    } else {
      if (perms.includes(route.path) && route.isActive) {
        allowedRoutes.push(route);
      }
    }
  }

  return allowedRoutes;
};

/**
 * format role name
 * @param {*} rolename
 * @returns
 */
export const formatRoleName = rolename => {
  return rolename
    .replaceAll('_', ' ')
    .split(' ')
    .map(w => w[0].toUpperCase() + w.substring(1).toLowerCase())
    .join(' ');
};
